<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="productDamageInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        @switch (productDamageInternationalForm?.controls?.damageType?.value) { @case
        (damageTypes.CONCEALED_INTERNAL_PACKAGING) {
        <sag-ui-select
            [required]="true"
            label="Package Type containing damaged products"
            placeholder=""
            formControlName="packageType"
            class="max-w-input"
        >
            @for (packageType of packageTypes | keyvalue; track $index) {
            <sag-ui-option [value]="packageType.value">{{ packageType.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-radio-group label="Was any Protective Packaging Used?" direction="row" [required]="true">
            <sag-ui-radio name="protectivePackagingUsed" formControlName="protectivePackagingUsed" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="protectivePackagingUsed" formControlName="protectivePackagingUsed" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        <sag-ui-select
            [required]="true"
            label="Package Type Condition"
            placeholder=""
            formControlName="packageTypeCondition"
            class="max-w-input"
        >
            @for (packageTypeCondition of packageTypeConditions | keyvalue; track $index) {
            <sag-ui-option [value]="packageTypeCondition.value">{{ packageTypeCondition.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-textarea
            [required]="true"
            label="Include any additional information regarding packaging"
            formControlName="additionalPackagingInfo"
            class="max-w-input"
        ></sag-ui-textarea>
        <div>
            <label class="text-sm text-shs-gray-1"
                ><span>*</span>Describe the condition of the item (select all that apply)</label
            >
            <div class="flex flex-col gap-2">
                @for (condition of itemConditions | keyvalue; track $index) {
                <sag-ui-checkbox
                    [checked]="itemConditionSelected(condition.value)"
                    (change)="toggleItemCondition(condition.value)"
                    >{{ itemConditionMapping[condition.value] }}</sag-ui-checkbox
                >
                }
            </div>
        </div>
        <app-attachments-input
            label="Attach visual evidence of the damage. Include image of internal and external packaging"
            [form]="productDamageInternationalForm!"
            [required]="true"
            controlName="visualEvidence"
        ></app-attachments-input>
        <sag-ui-radio-group
            label="Can you identify the carton ID# for the box/pallet the product was received in?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="canIdentifyCartonId" formControlName="canIdentifyCartonId" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (isTrue('canIdentifyCartonId')) {
        <sag-ui-input
            [required]="true"
            label="Carton / Pallet ID#"
            placeholder="3280823429"
            formControlName="cartonId"
            class="max-w-input"
        ></sag-ui-input>
        } } @default {
        <sag-ui-radio-group
            label="Did the Delivery Documentation note the potential issue?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="documentationNotedIssue" formControlName="documentationNotedIssue" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="documentationNotedIssue" formControlName="documentationNotedIssue" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        @if (isFalse('documentationNotedIssue')) {
        <sag-ui-textarea
            label="Please explain why it was not noted."
            formControlName="explanationOfMissingNote"
            class="max-w-input"
        ></sag-ui-textarea>
        }

        <app-attachments-input
            label="Attach a copy of the Delivery Documentation"
            [form]="productDamageInternationalForm!"
            [required]="true"
            controlName="deliveryDocumentation"
        ></app-attachments-input>

        <sag-ui-radio-group label="Damage Claim filed with Carrier?" direction="row" [required]="true">
            <sag-ui-radio name="damageClaimFiled" formControlName="damageClaimFiled" [value]="true">Yes</sag-ui-radio>
            <sag-ui-radio name="damageClaimFiled" formControlName="damageClaimFiled" [value]="false">No</sag-ui-radio>
        </sag-ui-radio-group>

        @if (isTrue('damageClaimFiled')) {
        <app-attachments-input
            label="Attach a copy of the documentation"
            [form]="productDamageInternationalForm!"
            [required]="true"
            controlName="damageClaimDocumentation"
        ></app-attachments-input>
        }

        <div>
            <label class="text-sm text-shs-gray-1"
                ><span>*</span>Describe the condition of the item (select all that apply)</label
            >
            <div class="flex flex-col gap-2">
                @for (condition of itemConditions | keyvalue; track $index) {
                <sag-ui-checkbox
                    [checked]="itemConditionSelected(condition.value)"
                    [disabled]="productDamageInternationalForm?.disabled ?? false"
                    (change)="toggleItemCondition(condition.value)"
                    >{{ itemConditionMapping[condition.value] }}</sag-ui-checkbox
                >
                }
            </div>
        </div>

        <sag-ui-input
            [required]="true"
            label="Carrier tracking number"
            placeholder="Enter the tracking number (e.g., 732974323)"
            formControlName="carrierTrackingNumber"
            class="max-w-input"
        ></sag-ui-input>

        <app-attachments-input
            label="Attach visual evidence of the damage. Include image of internal and external packaging"
            [form]="productDamageInternationalForm!"
            [required]="true"
            controlName="visualEvidence"
        ></app-attachments-input>
        } } @if (showFinancialAdjustment) {
        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <app-attachments-input [form]="productDamageInternationalForm!" controlName="relatedDocuments" />
        }
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
